import React from "react"
import PropTypes from "prop-types"
import { Dialog, DialogContent } from "@material-ui/core"
import UserProfileForm from "./UserProfileForm"
import messages from "./userProfileMessage"
import useSmartFormat from "../../../i18n/useSmartFormat"
import DialogTitleWithClose from "../../../component/dialog/DialogTitleWithClose"

function getViewModel(profile) {
  if (!profile) {
    return {
      title: messages.newUserProfile,
      initialValues: undefined
    }
  }

  return {
    title: messages.editUserProfile,
    initialValues: profile
  }
}

export default function UserProfileFormDialog(props) {
  const { open, close, handleSave, profile } = props
  const format = useSmartFormat()
  const dialogViewModel = getViewModel(profile)

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitleWithClose onClose={close}>
        {format(dialogViewModel.title)}
      </DialogTitleWithClose>
      <DialogContent>
        <UserProfileForm
          handleSave={handleSave}
          initialValues={dialogViewModel.initialValues}
        />
      </DialogContent>
    </Dialog>
  )
}

UserProfileFormDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  profile: PropTypes.any
}

UserProfileFormDialog.defaultProps = {
  profile: undefined
}
